import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Package } from 'lucide-react';
import { PageHero } from '../components/PageHero';
import { Breadcrumbs } from '../components/Breadcrumbs';
import { sectors } from '../data/sectors';
import { products } from '../data/products';
import { ProductPlaceholder } from '../components/ProductPlaceholder';
import { PartnerCTA } from '../components/PartnerCTA';
export function SectorsHubPage() {
  return <>
      <PageHero label="Manufacturing" title="Our Markets" subtitle="Chiltern Global provides specialist manufacturing support to four core sectors, delivering compliant, specification-grade equipment to defence, police, prison, and medical organisations." data-id="element-1375" />

      <Breadcrumbs items={[{
      label: 'Manufacturing',
      to: '/manufacturing'
    }, {
      label: 'Our Markets'
    }]} data-id="element-1376" />

      <section className="py-0" data-id="element-1377">
        <div className="" data-id="element-1378">
          {sectors.map((sector, index) => {
          // Get 3 products for this sector
          const sectorProducts = products.filter(p => p.sectors.includes(sector.slug)).slice(0, 3);
          const isEven = index % 2 === 0;
          return <div key={sector.slug} id={sector.slug} className={`scroll-mt-32 ${isEven ? 'bg-white' : 'bg-slate-100 border-y border-steel-200'}`} data-id="element-1379">
                <div className="max-w-7xl mx-auto px-6 lg:px-8 py-20" data-id="element-1380">
                  <div className="flex flex-col lg:flex-row gap-12" data-id="element-1381">
                    {/* Sector Info - Navy Panel Style */}
                    <div className="lg:w-1/3" data-id="element-1382">
                      <div className="aspect-video bg-navy-900 rounded-sm overflow-hidden mb-6 flex items-center justify-center p-8 relative group" data-id="element-1383">
                        <img src={sector.image} alt={sector.name} className="absolute inset-0 w-full h-full object-cover opacity-40 group-hover:opacity-50 transition-opacity" data-id="element-1384" />
                        <h3 className="text-3xl font-bold text-white text-center relative z-10" data-id="element-1385">
                          {sector.name}
                        </h3>
                      </div>
                      <h2 className="text-3xl font-bold text-navy-900 mb-4" data-id="element-1386">
                        {sector.name}
                      </h2>
                      <p className="text-steel-600 mb-6 leading-relaxed" data-id="element-1387">
                        {sector.shortDescription}
                      </p>
                      <Link to={`/manufacturing/markets/${sector.slug}`} className="inline-flex items-center justify-center px-6 py-3 bg-navy-900 text-white font-bold uppercase tracking-wider text-sm rounded-sm hover:bg-cg-orange-600 transition-colors" data-id="element-1388">
                        View Sector Profile
                      </Link>
                    </div>

                    {/* Specialist Equipment */}
                    <div className="lg:w-2/3" data-id="element-1389">
                      <h3 className="text-sm font-bold text-navy-900 uppercase tracking-wider mb-6 flex items-center gap-2" data-id="element-1390">
                        <Package className="w-4 h-4 text-cg-orange-600" data-id="element-1391" />{' '}
                        Specialist Equipment Capabilities
                      </h3>
                      <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1392">
                        {sectorProducts.map(product => <Link key={product.slug} to={`/products/${product.slug}`} className="group bg-white border border-steel-200 hover:border-cg-orange-600 transition-colors rounded-sm" data-id="element-1393">
                            <div className="aspect-square overflow-hidden bg-white relative rounded-t-sm" data-id="element-1394">
                              <ProductPlaceholder aspectRatio="1/1" className="w-full h-full" data-id="element-1395" />
                            </div>
                            <div className="p-4" data-id="element-1396">
                              <h4 className="text-sm font-bold text-navy-900 mb-1 group-hover:text-cg-orange-600 transition-colors line-clamp-1" data-id="element-1397">
                                {product.name}
                              </h4>
                              <p className="text-xs text-steel-500 line-clamp-2 mb-3" data-id="element-1398">
                                {product.shortDescription}
                              </p>
                              <span className="text-[10px] font-bold text-navy-900 uppercase tracking-wider flex items-center gap-1" data-id="element-1399">
                                View Spec{' '}
                                <ArrowRight className="w-3 h-3 group-hover:translate-x-1 transition-transform" data-id="element-1400" />
                              </span>
                            </div>
                          </Link>)}
                      </div>
                    </div>
                  </div>
                </div>
              </div>;
        })}
        </div>
      </section>

      <PartnerCTA data-id="element-1401" />
    </>;
}